import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Router } from "@angular/router";
import { ZipCodeValidator } from "@centiro/zipcode-validator";
import * as LocaleList from "@centiro/locale-list";
import { clientConfig } from "../../../../shared/constant/app.constant";
import { NavButton } from "../../../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../../../shared/services/app-flow/app-flow.service";
import { updateOrderAddressFromReturnOrderAction } from "../../../../store/actions/order.actions";

@Component({
  selector: "update-address",
  templateUrl: "update-address.component.html",
  styleUrls: ["./update-address.component.scss"],
})
export class UpdateComponent {
  countries = [];
  country: any;
  countryName: any;
  returnOrder: any;
  orderAddress: any;
  route: any;
  cancelButton: any;
  showerror = false;
  zipCodeValidation: boolean = true;
  addressinfo: AddressInfo = {};
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
  screenNav: NavButton = {
    buttonText: "Select return option",
    cssClass: "back-btn",
    routeUrl: "/d/shippingoption",
  };
  enableEmailText:boolean

  constructor(private router: Router, private store: Store<AppState>, private appFlowService: AppFlowService) {
    const countriesList = clientConfig.COUNTRIESALLOWED;

    if (this.checkCountryStr(countriesList[0])) {
      for (const element of countriesList) {
        var str = element.split("-",2);
        const countryData = {
          id: str[1],
          name: LocaleList.getByLocaleCode(element).nativeName,
        };
        this.countries.push(countryData);
      }
    }
    else {
      for (const element of countriesList) {
        const countryData = {
          id: element,
          name: LocaleList.getByCountryCode(element)[0].location,
        };
        this.countries.push(countryData);
      }
    }

    this.returnOrder = this.store.pipe(select("returnOrder"));
    this.returnOrder.subscribe((ro) => {
      this.orderAddress = ro.orderAddress;
      this.addressinfo.name = ro.orderAddress.name;
      this.addressinfo.city = ro.orderAddress.city;
      this.addressinfo.state = ro.orderAddress.state;
      this.addressinfo.additionalAddressInformation = ro.orderAddress.additionalAddressInformation;
      this.addressinfo.street = ro.orderAddress.streetAddress;
      this.addressinfo.zipcode = ro.orderAddress.zipcode;
      this.addressinfo.email = ro.orderAddress.contactInfo.email;
      this.country = ro.orderAddress.isoCountry;
      if (
        ro.orderAddress.isoCountry === "" ||
        ro.orderAddress.city === "" ||
        ro.orderAddress.streetAddress === "" ||
        ro.orderAddress.name === ""
      ) {
        this.cancelButton = false;
        this.showerror = true;
      } else if (
        ro.orderAddress.isoCountry === undefined ||
        ro.orderAddress.city === undefined ||
        ro.orderAddress.streetAddress === undefined ||
        ro.orderAddress.name === undefined
      ) {
        this.cancelButton = false;
        this.showerror = true;
      } else {
        this.cancelButton = true;
        this.showerror = false;
      }
    });
    this.countryName = this.countries.filter((x) => x.id === this.country)[0].name;
    this.enableEmailText=this.orderAddress.contactInfo.email === "" || this.orderAddress.contactInfo.email === undefined?false:true;
  }

  checkCountryStr(str) {
    return str.includes('-');
  }

  selectCountry(event: any) {
    this.country = event.target.value;
    this.countryName = this.countries.filter((x) => x.id === event.target.value)[0].name;
  }

  saveAddress() {
    let latitude = this.orderAddress.latitude;
    let longitude = this.orderAddress.longitude;
    const firstName = this.orderAddress.contactInfo.firstName;
    const lastName = this.orderAddress.contactInfo.lastName;
    const phone = this.orderAddress.contactInfo.phone;

    if (this.AddressChanged()) {
      latitude = null;
      longitude = null;
    }
    this.store.dispatch(
      updateOrderAddressFromReturnOrderAction({
        payload: {
          name: this.addressinfo.name,
          city: this.addressinfo.city,
          state: this.addressinfo.state,
          streetAddress: this.addressinfo.street,
          zipcode: this.addressinfo.zipcode,
          additionalAddressInformation: this.addressinfo.additionalAddressInformation,
          isoCountry: this.country,
          latitude: latitude,
          longitude: longitude,
          contactInfo: {
            firstName: firstName,
            lastName: lastName,
            email: this.addressinfo.email,
            phone: phone,
          },
        },
      })
    );

    this.zipCodeValidation = true;
    if (this.addressinfo.zipcode)
      this.zipCodeValidation = ZipCodeValidator.isValid(this.addressinfo.zipcode, this.country);

    if (
      this.addressinfo.name &&
      this.addressinfo.city &&
      this.addressinfo.street &&
      this.country &&
      this.zipCodeValidation &&
      this.validateEmail(this.addressinfo.email)
    ) {
      this.showerror = false;
      this.router.navigate(["/d/shippingoption"]);
    } else {
      this.addressinfo.name = this.orderAddress.name;
      this.addressinfo.city = this.orderAddress.city;
      this.addressinfo.street = this.orderAddress.streetAddress;
      this.addressinfo.zipcode = this.orderAddress.zipcode;
      this.addressinfo.email = this.orderAddress.contactInfo.email;
      this.country = this.orderAddress.isoCountry;
      this.showerror = true;
      this.cancelButton = false;
    }
  }
  AddressChanged() {
    if (
      this.orderAddress.city !== this.addressinfo.city ||
      this.orderAddress.state !== this.addressinfo.state ||
      this.orderAddress.streetAddress !== this.addressinfo.street ||
      this.orderAddress.zipcode !== this.addressinfo.zipcode ||
      this.orderAddress.contactInfo.email !== this.addressinfo.email
    )
      return true;

    return false;
  }

  validateEmail(email: string): boolean {
    if(email === "" || email === undefined)
    {
      return true;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
}
